import { Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Activities from './activities/Activities'
import MemoryGame from './activities/games/MemoryGame'
import Schutle from './activities/games/Schutle'
import Accounts from './admin/accounts/Accounts'
import AdminLogin from './admin/auth/Login'
import AdminSignup from './admin/auth/Signup'
import Credits from './admin/credits/Credits'
import Aggregate from './aggregate/Aggregate'
import { RequireAdminAuth, RequireRole } from './Auth'
import ADHDForm from './brain/adhd/ADHDForm'
import BrainLayout from './brain/BrainLayout'
import Dashboard from './brain/Dashboard'
import DementiaReport from './brain/dementia/DementiaReport'
import EEGUploadForm from './brain/eeg/EEGUploadForm'
import ChildrenForm from './children/Children'
import SelectChild from './children/SelectChild'
import EEGAnalytics from './eeg/EEGAnalytics'
import AdminLayout from './layouts/AdminLayout'
import DashboardLayout from './layouts/DashboardLayout'
import ForgotPassword from './login/ForgotPassword'
import Login from './login/Login'
import Neuro from './neuro/Neuro'
import NotFound from './NotFound'
import OverviewCorp from './overview/OverviewCorp'
import PrivateRoute from './PrivateRoute'
import PersonalityInsights from './profile/PersonalityInsights'
import ProtectedRoute from './ProtectedRoute'
import ActivityDetails from './recommendation-system/ActivityDetails'
import RecommendationLayout from './recommendation-system/Layout'
import RecommendationSystem from './recommendation-system/RecommendationSystem'
import SubjectInsights from './subject/SubjectInsights'
import Unauthorized from './Unauthorized'
import EEGPipeline from './brain/pipeline/EEGPipeline'
import { users } from './utils/users'

function App() {
  return (
    <>
      <Routes>
        <Route path='/admin/login' element={<AdminLogin />} />
        <Route path='/admin/signup' element={<AdminSignup />} />
        {/* Admin Routes */}
        <Route
          path='admin'
          element={
            <RequireAdminAuth>
              <AdminLayout />
            </RequireAdminAuth>
          }
        >
          <Route element={<RequireRole roles={['admin']} />}>
            <Route path='credits' element={<Credits />} />
            <Route path='accounts' element={<Accounts />} />
          </Route>
        </Route>

        <Route path='/login' element={<Login />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />

        <Route path='/children' element={<ChildrenForm />} />
        <Route path='/children/add' element={<SelectChild />} />

        <Route element={<PrivateRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path='/' element={<OverviewCorp />} />
            <Route path='/dashboard' element={<BrainLayout />}>
              <Route index element={<Dashboard />} />
              <Route path='screening' element={<EEGUploadForm />} />
              <Route
                path='adhd'
                element={
                  <ProtectedRoute allowed={[users.ajay, users.research]}>
                    <ADHDForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path='dementia'
                element={
                  <ProtectedRoute allowed={[users.ajay, users.research]}>
                    <DementiaReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path='pipeline'
                element={
                  <ProtectedRoute allowed={[users.ajay, users.research]}>
                    <EEGPipeline />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path='/neuro-diagnosis'
              element={
                <ProtectedRoute allowed={[users.ajay, users.research]}>
                  <Neuro />
                </ProtectedRoute>
              }
            />
            <Route
              path='/eeg-analytics'
              element={
                <ProtectedRoute allowed={[users.ajay]}>
                  <EEGAnalytics />
                </ProtectedRoute>
              }
            />
            <Route path='/profile' element={<PersonalityInsights />} />
            <Route path='/session' element={<SubjectInsights />} />
            <Route path='/aggregate' element={<Aggregate />} />

            <Route path='/activities' element={<Activities />} />
            <Route path='/games/memorygame' element={<MemoryGame />} />
            <Route path='/games/schutle' element={<Schutle />} />

            <Route path='/recommendations' element={<RecommendationLayout />}>
              <Route index element={<RecommendationSystem />} />
              <Route path=':activityName' element={<ActivityDetails />} />
            </Route>

            <Route path='/unauthorized' element={<Unauthorized />} />
          </Route>
        </Route>

        <Route path='*' element={<NotFound />} />
      </Routes>
      <ToastContainer />
    </>
  )
}

export default App
